
import { FC } from 'react';
import { HeaderLeft } from '../../TopNavigation/HeaderLeft';
import { RecommendationHeaderImage } from './RecommendationHeaderImage';
import { SPACING } from '../../../config/designSystem/Spacing';
import { View } from 'react-native';
import { concatPath } from '../../../utils/links/concatPath';
import { dashboardKey, dashboardStackKey, privateKey } from '../../../constants/routeKeys';
import { router } from 'expo-router';
import { useProgramBackgroundHeight } from '../../Program/ProgramBackground';


type HeaderImageWithCardProps = {
    featureId: string
};

export const  HeaderImageWithCard:  FC<HeaderImageWithCardProps> = ({ featureId }) => {

  const HEIGHT = useProgramBackgroundHeight();
  const goToDashboard = () => {
    router.navigate(concatPath([privateKey, dashboardStackKey, dashboardKey], -1) as string);
  };
  return(
    <View>
      <HeaderLeft topPosition={SPACING['sp-32']} leftPosition={SPACING['sp-32']} onPress={goToDashboard}/>
      <RecommendationHeaderImage height={HEIGHT} featureId={featureId}/>
    </View>
  );

};